import React, {lazy} from 'react';
import { IonButton, IonContent, IonModal, IonPage, withIonLifeCycle, IonSelect, IonSelectOption, IonItem, IonInput, IonLabel,IonDatetime, IonIcon, IonCheckbox, isPlatform, IonChip, IonLoading, IonToolbar, IonButtons, IonCol, IonRow, IonCard, IonBadge, IonHeader, IonTitle,
} from '@ionic/react';
import { addOutline, caretDown, close, closeCircle, filterCircle, list, locationOutline, lockClosed, map, mic, people, person, send, walk, walkOutline } from 'ionicons/icons';
import { connect } from 'react-redux';
import { History } from "history";
import { formatDate, formatEnd } from "../helpers/format_date";
import { CONFIG } from '../constants'
import Api from "../services/Api";
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween'
import { userState } from '../redux/types/logInTypes';
import { setView, setTeam, updateFilter } from '../redux/actions/logInActions';
import FirebaseProvider from '../services/FirebaseAnalytics'
import FilterDropdown from '../components/FilterDropdown';
import ModalHeader from '../components/ModalHeader';
import GoogleMapImage from "../components/GoogleMapImage";
import './FindWalks.scss';
import { goToPage, goToPageWithState } from '../helpers/app_actions';
import { getDistanceFromLatLonInKm } from '../helpers/distance_helpers';
import { WalkI } from '../interfaces/Walk';
import { RootState } from '../redux/reducers';
// import CurrentWalk from '../components/CurrentWalk/CurrentWalk';
import { setFilterTeamArrAction } from '../redux/actions/filterTeamActions';
// import { openPreview } from '../redux/actions/filterTeamActions';
import { closePreview, openPreview } from '../redux/actions/walkPreview'

import LocalTeamFilter from '../services/LocalTeamFilter'
const MapContainer = lazy(() => import ('../components/MapContainer'))

dayjs.extend(isBetween)

declare var google: any;

interface ComponentProps {
  friends: any
  history: History;
  allWalks: any
  location: any
  user: userState
  setView: Function
  setTeam: Function
  setFilterTeamArrAction: Function
  openPreview: Function
  closePreview: Function
  updateFilter: Function
  viewMode: string
  loggedIn: boolean
  logIn: any
  teamFilter: (number | null)[]
}

interface ComponentState {
  filtermodal: boolean
  view: boolean
  loggedIn: boolean;
  walks: Array<any>;
  markers: Array<any>;
  loaded: boolean;
  profilePicture: string;
  showBooked: boolean;
  showSelectWhen: boolean;
  showFilter: boolean
  disabled: boolean;
  filter: any
  filterResult: Array<any>
  submitError: boolean
  myPosition: boolean | null
  errorString: String,
  viewMode: string,
  teamId: number | null
  openProfile: boolean
  chosenPerson: {
    firstName: string
    id: number
    picture: string
  },
  setNearby: boolean
  walksOnSame: Array<WalkI>
  walksOnSameOpen: boolean
}

class HomePage extends React.Component<ComponentProps, ComponentState>  {
  private fba = FirebaseProvider.getInstance()
  private LocalTeamFilter = LocalTeamFilter.getInstance()

  api = Api.getInstance();
  innerWidth: number;
  backgroundMapWidth: number;
  backgroundMapHeight: number;
  backgroundMapWidthPx: string;
  backgroundMapHeightPx: string;
  mapWidth: number;
  mapHeight: number;
  when: string = 'week';
  whenStr: string = 'i veckan';
  scrollHeight: Number;

  constructor(props: any) {
    super(props);
    this.state = {
      filtermodal: false,
      view: true,
      walks: [],
      markers: [],
      profilePicture: this.api.profile.picture,
      loggedIn: this.api.loggedIn,
      loaded: false,
      showBooked: false,
      showSelectWhen: false,
      showFilter: false,
      disabled: false,
      filter: {
        teamArr: [],
        isSet: false,
        count: [],
        walkType: null,
        place: null,
        placeLngLat: {
          lng: null,
          lat: null
        },
        date: null,
        time: null,
        when: 'all',
        whenIsSet: false,
        searchRadius: {
          value: 10000,
          isSet: false
        },
        audio: null
      },
      filterResult: [],
      submitError: false,
      errorString: '',
      myPosition: null,
      viewMode: 'public',
      teamId: null,
      openProfile: false,
      chosenPerson: {
        firstName: '',
        id: 0,
        picture: ''
      },
      setNearby: false,
      walksOnSame: [],
      walksOnSameOpen: false
   }

    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 600) {
      this.innerWidth = 600
    }

    if(window.innerHeight < 700) {
      this.backgroundMapHeight = Math.round(this.innerWidth * 0.4);

      if(isPlatform('ios') || isPlatform('android')){
        this.backgroundMapHeight = Math.round(this.innerWidth * 0.7);
      }
    } else if(window.innerHeight < 900) {
      this.backgroundMapHeight = Math.round(this.innerWidth * 0.5);

      if(isPlatform('ios') || isPlatform('android')){
        this.backgroundMapHeight = Math.round(this.innerWidth * 0.7);
      }
    } else {
      this.backgroundMapHeight = Math.round(this.innerWidth * 0.7);
    }
  
    this.backgroundMapWidth = this.innerWidth;
    this.backgroundMapWidthPx = this.backgroundMapWidth + 'px';
    this.backgroundMapHeightPx = this.backgroundMapHeight + 'px';
    this.mapWidth = this.innerWidth - 32;
    this.mapHeight = Math.round(this.mapWidth / 2);
    this.scrollHeight = document.documentElement.clientHeight - 397 - this.mapHeight - 70
  }

  ionViewWillEnter() {
    if (this.api.loggedIn !== this.state.loggedIn) {
      this.setState({
        profilePicture: this.api.profile.picture, 
        loggedIn: this.api.loggedIn
      });
    }

    this.fba.trackView('Find_Walks')
  }

  ionViewDidEnter() {
    this.LocalTeamFilter.fetchTeamArrLocally()
    this.LocalTeamFilter.storeTeamArrLocally()

    this.checkSetFilter().then(res => {
      this.setTeamArr()
      this.fetchWalks()
    })
  }

  componentDidMount = () => {
    this.handleScroll()
  }

  setTeamArr = () => {
    let teamArr:(number | null)[] = []
    if(JSON.parse(window.localStorage.Team_arr).length > 0) {
      teamArr = JSON.parse(window.localStorage.Team_arr)
    } else {
      // console.log('2')

      // if(this.props.user.teams.length > 0) {
      //   console.log('3', this.props.user.teams)

      //   teamArr.concat([0, null])
      //   for(let i = 0; i < this.props.user.teams.length; i ++) {
      //     console.log('4', this.props.user.teams[i].teamId)
      //     teamArr.push(this.props.user.teams[i].teamId)
      //   }
      // } else {
      //   teamArr.concat([0, null])
      // }
    }

    this.setState({filter: {
      ...this.state.filter,
      teamArr: teamArr
    }})
    this.props.setFilterTeamArrAction(teamArr)
  }

  checkSetFilter = async (): Promise<any> => {
    new Promise((resolve) => {
      const filter = this.props.user.filter
      if(filter !== null) {
        if(filter.location === null && filter.dayTime === null) {
          this.setState({
            filter: {
              ...this.state.filter,
              isSet: false,
            }
          }, () => resolve(true))
        } else {   
          let radiusSet = false       
          if(filter.radius !== 10000) {
            radiusSet = true
          }
          this.setState({
            filter: {
              ...this.state.filter,
              isSet: true,
              place: filter.location,
              placeLngLat: {
                lat: filter.lat,
                lng: filter.lng
              },
              time: filter.dayTime,
              searchRadius: {
                value: filter.radius,
                isSet: radiusSet
              }
            }
          }, () => resolve(true))
        }

      } else {

      }
    })
  }

  componentDidUpdate = (prevProps: any, prevState: any) => {
    const filter = this.state.filter
    this.handleScroll()

    if(prevState.filter.audio !== filter.audio){
      this.filterWalks(this.state.filter)
    }

    if(prevState.filter.place !== filter.place || prevState.filter.time !== filter.time || prevState.filter.date !== filter.date || prevState.filter.audio !== filter.audio) {
      this.checkFilterFields()
    }

    if(prevState.filter.count !== filter.count && filter.count.length === 0) {
      this.setState({
        filter: {
          ...filter,
          isSet: false 
        }
      })
      
    }

    if(prevState.filter.date !== filter.date && filter.date !== null) {
      this.setState({ 
        filter: {
          ...filter,
          whenIsSet: true,
          when: 'all'
      }})
    }

    if(prevProps.viewMode !== this.props.viewMode && this.props.loggedIn) {
      this.fetchWalks()
    }

    if(this.state.filter.whenIsSet && prevState.filter.when !== this.state.filter.when) {
      this.fetchWalks()
    }

    if(this.state.view !== prevState.view) {
      this.fetchWalks()
    }

    if(prevState.setNearby !== this.state.setNearby){
      // console.log('is toggle', this.state.setNearby, this.state)
        // this.toggleNearby()
    } 

    if(prevProps.user.teams !== this.props.user.teams) {
      this.setTeamArr()
    }
  }

  setNearby = (value: boolean) => {
    this.setState({
      setNearby: value
    })
  }

  toggleNearby = () => {
    let walkArray = [...this.state.walks]
    if(this.state.setNearby) {
      for(let i = 0; i < walkArray.length; i++) {
        let distance = getDistanceFromLatLonInKm(this.props.location.lat, this.props.location.lng, walkArray[i].lat, walkArray[i].lng); 
        walkArray[i].distance = distance;
      }

      walkArray.sort(function(a, b) {
        return a.distance - b.distance
     });
     
      this.setState({
        filterResult: walkArray
      })
    } else {
      this.setState({
        filterResult: walkArray
      })
    }
  }

  private fetchWalks = () => {
    this.getAllWalks()
  }

  private getAllWalks = () => {
    const all = `find_walks?when=${this.state.filter.when}`
    const  teams = `find_walks?when=${this.state.filter.when}&teams=all`

    this.api.get(all).then(res => {
     res.json().then(data => data.walks).then(walks => {
      //  console.log(walks);
        let list: WalkI[] = walks
        let disabled = walks ? true : false

        this.api.get(teams).then(res => {
          res.json().then(data => {
          this.setState({   
            walks: list.concat(data.walks).sort((a: any, b: any) => {
              return new Date(a.start).getTime() - new Date(b.start).getTime()
            }),
            loaded: true,
            disabled : disabled,
          }, () => {
            this.filterWalks(this.state.filter)
          });
          })
        })
      })
    })
  }

  public goToWalk = (walkId: number, full: boolean) => {
    const walkClick = this.state.filterResult.filter(walk => walk.id === walkId)[0]
    const walksSame = this.state.filterResult.filter(walk => walk.lat === walkClick.lat && walk.lng === walkClick.lng)
    const isMeet = walksSame.find(walk => walk.hasCoordinates)

    if(full) {
      this.setState({ showBooked: true });
    } else if(walksSame.length > 1 && isMeet && this.state.view){
      goToPageWithState('/walk/home/walks', {
        walksOnSame: walksSame,
        mapWidth: this.mapWidth,
        mapHeight: this.mapHeight,
        view: this.state.view
      })
      
      this.setState({
        walksOnSame: walksSame,
        walksOnSameOpen: true
      })
    } else { 
      if(this.state.view) {
        this.props.openPreview(this.state.walks.filter(walk => walk.id === walkId)[0])
      } else {
        this.props.history.push('/walk/walk/' + walkId);
      }
    }
  }

  private showCreateWalk = () => {
    this.setState({ showBooked: false });
    this.props.history.push('/walk/create');
  }

  private showTesting = () => {
    this.props.history.push('/walk/testing');
  }

  isPrivateWalk = (walks: any) => {
    return walks.filter((walk: any) => {
      if(walk.privateWalk) {
        if(walk.availableTo.filter((person: any) => person.id
        )[0].id === this.props.user.person.id) {
          return walk
        }
        if(walk.editable === 1) {
          return walk
        }
        return null
      } else if(!walk.privateWalk) {
        return walk
      }
        return null
      }
    )
  }

  isAudioWalk = (walks: any) => {
    return walks.filter((walk: WalkI) => {
      if(walk.hasTalk){
        return walk
      } else {
        return null
      }
    })
  }

  filterNetwork = (walks: WalkI[]) => {
    const teamId = this.state.filter.teamArr as (number | null)[]
    let result: WalkI[] = []

    if(teamId.find(obj => obj === 0)) {
      result = walks
    } else {
      result = walks.filter((item) => {
        if(teamId.indexOf(item.teamId) !== -1 || item.booked === 1) {
          return walks
        } else {
          return null
        }
      });
    }
    return result
  }

  toolbarFilter = () => {
    const teamChips = this.props.logIn.user.teams.filter((item: any) => {
      return this.props.teamFilter.indexOf(item.teamId) !== -1;
    })
    const foundPublic = this.props.teamFilter.find(e => e === null)
    const foundAll = this.props.teamFilter.find(e => e === 0)
    return <>
      { foundAll === 0 ? <IonChip color="teal" class="p-2 "><IonLabel class="font_small">{this.api.tr('find_page_network')}</IonLabel></IonChip>
      : 
      <>
        { foundPublic === null ? <IonChip color="teal" class="p-2"><IonLabel class="font_small">{this.api.tr('public')}</IonLabel></IonChip> : null }
        { teamChips[0] ? 
        <IonChip color="teal" class="p-2">
          <IonLabel class="font_small chip-ellipsis">{teamChips[0].teamName}</IonLabel>
        </IonChip>
        : null }
        { teamChips.length >= 2 ? 
        <IonChip class="p-2" color="teal">
          <IonIcon icon={addOutline} />
          {teamChips.length - 1}
        </IonChip>
        : 'No filter'}
      </>
      }
    </>
  }

  filterWalks = (filter: any) => {
    let walksToFilter = this.filterNetwork(this.state.walks)
    let filteredMarkers: any = [];

    const teamWalks = this.isPrivateWalk(walksToFilter)
    if(filter.isSet) {
      const walksInRange = this.calculateDistanceBetween({ 
          lat: filter.placeLngLat.lat, 
          lng: filter.placeLngLat.lng 
        }, 
        teamWalks).filter((walk: any) => walk)

        const walksInTime = walksInRange.filter((walk: any) => {
        const morning = /([0][5-9])(:)|([1][0-1])(:)/
        const day = /([1][2-7])(:)/
        const evening = /([1][8-9](:)|[2][0-2])(:)/
        
        if(filter.time === null) {
          return walk
        } else if(filter.time === '05-11' && walk.start.match(morning)) {
          return walk
        } else if (filter.time === '12-17' && walk.start.match(day)) {
          return walk
        } else if (filter.time === '18-22' && walk.start.match(evening)) {
          return walk
        }
        return null
      })

      const walksOnDate = walksInTime.filter((walk: any) => {
        if(filter.date === null) {
          return walk
        } else if(walk.start.includes(filter.date)) {
          return walk
        }
        return null
      })

      const audioWalks = walksOnDate.filter((walk: WalkI) => {
        if(filter.audio) {
          if(walk.hasTalk) {
            return walk
          } else {
            return null
          }
        } else {
          return walk
        }
      })
      walksToFilter = audioWalks
    } else {
      // walksToFilter = teamWalks
      walksToFilter = this.filterNetwork(teamWalks)

    }

    walksToFilter.filter((marker:any) => {
      let full: boolean;
        if (marker.bookings >= marker.maxBookings) {
          if (marker.bookedByYou) {
            full = false;
          } else if (marker.editable) {
            full = false;
          } else {
            full = true;
          }
        } else {
          full = false;
        }

       if(marker.hasCoordinates) {
        filteredMarkers.push({
          lat: marker.lat,
          lng: marker.lng,
          walkId: marker.id,
          zoom: marker.zoom,
          name: marker.name,
          full: full,
          booked: marker.booked,
          personId: marker.personId,
          personName: marker.personName,
          personPicture: marker.personPicture,
          start: marker.start,
          lengthMinutes: marker.lengthMinutes,
          bookings: marker.bookings,
          maxBookings: marker.maxBookings,
          bookedByYou: marker.bookedByYou,
          editable: marker.editable
        });
       } 

      return null
    })
    this.setState({
      filterResult: walksToFilter,
      markers: filteredMarkers,
      loaded: true,
    }, () => {})
  }

  newFilter = (walks: WalkI[]) => {
    if(this.state.filter.teamArr.length === 0){
      return walks
    }
  }

  closeModal = () => {
    this.setState({
      showFilter: false
    })
  }

  onInputChange = (e: any) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.id]: e.target.value,
      },
      submitError: false,
    })
    if(this.state.filter.place === '') {
      this.setState({
        filter: {
          ...this.state.filter,
          place: null
        }
      })
    }
  }

  onDateInputChange = (e: any) => {
    const date = e.target.value.match(/([2][0-1][2][0-9]-[0-3][0-9]-[0-3][0-9])/)
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.id]: date[0],
      },
      submitError: false,
    })
  }

  onRadiusInputChange = (e: any) => {
    this.setState({
      filter: {
        ...this.state.filter,
        searchRadius: {
          value: e.target.value,
          isSet: true
        }
      }
    })
  }

  onMyPositionFilterChange = (e: any) => {
    this.setState({
      filter: {
        ...this.state.filter,
        myPosition: e.detail.checked,
      }
    })
  }

  onFilterSubmit = async (e: any) => {
    e.preventDefault()
    if(!this.state.filter.myPosition && this.state.filter.place === null && this.state.filter.time === null && this.state.filter.date === null) {
      this.setState({
        submitError: true,
        errorString: this.api.tr('filter_error_choose')
      })
    } else if(this.state.filter.myPosition && this.props.location.lat === null){
      this.setState({
        submitError: true,
        errorString: this.api.tr('position_error'),
        filter: {
          ...this.state.filter,
          myPosition: false
        }
      })
    } else if(this.state.filter.myPosition) {
      this.setState({
        showFilter: false,
        filter: {
          ...this.state.filter,
          isSet: true,
          place: this.api.tr('my_position'),
          placeLngLat: {
            lat: this.props.location.lat,
            lng: this.props.location.lng
          }
        }
      },() => {
        this.filterWalks(this.state.filter)
        this.submitFilter()
    })
    } else if (!this.state.filter.myPosition && this.state.filter.place !== null) {
      await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${this.state.filter.place}&key=${CONFIG.GOOGLE_KEY}&callback=${Function.prototype}`)
      .then(res => res.json())
      .then(data => {
        this.setState({
          showFilter: false,
          filter: {
            ...this.state.filter,
            isSet: true,
            placeLngLat: {
              lat: data.results[0].geometry.location.lat,
              lng: data.results[0].geometry.location.lng
            }
          }
        }, () => {
          this.filterWalks(this.state.filter)
          this.submitFilter()
        }
        )
      })
      .catch(e => {
        this.setState({
          submitError: true,
          errorString: this.api.tr('place_error'),
        })
      })
    } else if(this.state.filter.place === null && this.state.filter.time === null && this.state.filter.date === null) {
    } else {
      this.setState({
          showFilter: false,
          filter:{
          ...this.state.filter,
          isSet: true
        }
      }, () => {
          this.filterWalks(this.state.filter)
          this.submitFilter()
        }
      )
    }
  }

  submitFilter = () => {
    const filterData = {
      location: this.state.filter.place,
      lat: this.state.filter.placeLngLat.lat,
      lng: this.state.filter.placeLngLat.lng,
      radius: this.state.filter.searchRadius.value,
      dayTime: this.state.filter.time
    }

    this.api.post('filter/save', filterData).then(res => {
      this.props.updateFilter(filterData)
    })
  }

  calculateDistanceBetween = (searchedCoord: any, walks: any) => {
    let walksInRange = walks
    if(searchedCoord.lat !== null) {
      const searchedLocation = new google.maps.LatLng(searchedCoord.lat, searchedCoord.lng)
      const distance = google.maps.geometry.spherical.computeDistanceBetween
  
      walksInRange = walks.filter((walk: any) => {
        const markerLatLng = new google.maps.LatLng(walk.lat, walk.lng)
        if(distance(searchedLocation, markerLatLng).toFixed() < this.state.filter.searchRadius.value) {
          return walk
        }
        return null
      })
    }
    return walksInRange
  }

  getTimeSpan = (walks: any, time: any) => {
    const today = dayjs().format('YYYY-MM-DD hh:mm')
    const endOfValue = dayjs().clone().endOf(time).format('YYYY-MM-DD hh:mm')

    const walksWhen = walks.filter((walk: any) => {
      if(time === 'all'){
        return walks
      } else if(time === 'today') {
        if(dayjs(walk.start).isSame(today, 'day')){
          return walk
        }
      } else {
        if (dayjs(walk.start).isBetween(today, endOfValue, time, '[]')) {
          return walk
        }
      }
      return null
    })
    return walksWhen
  }

  openFilter = (e: any) => {
    e.preventDefault()
    this.setState({ 
      showFilter: true
    })
  }

  clearFilter = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        isSet: false,
        audio: false,
        walkType: null,
        place: null,
        placeLngLat: {
          lng: null,
          lat: null
        },
        date: null,
        time: null,
        searchRadius: {
          value: 10000,
          isSet: false
        }
      }
    },() => {
      this.filterWalks(this.state.filter)
      this.submitFilter()
    })
    this.scrollToTop()
    // test_filter_delete
    this.api.get('filter/delete')
  }

  checkFilterFields = () => {
    const filter = this.state.filter;

    const obj: any = {
      place: filter.place,
      time: filter.time,
      date: filter.date,
      // audio: filter.audio
    }

    for (let key in obj) {
      if(obj[key] !== null && !filter.count.includes(key)) {
        filter.count.push(key)
      } else if(obj[key] === null && filter.count.includes(key)) {
        const arr = filter.count.filter((type: any) => type !== key)
        this.setState({
          filter: {
            ...filter,
            count: arr
          }
        },() => {
          this.filterWalks(this.state.filter)
          this.submitFilter()
        })
      }
    }
  }

  clearFilterField = (e: any) => {
    e.preventDefault()
    if(e.currentTarget.id === 'searchRadius') {
      this.setState({
        filter:{
          ...this.state.filter,
          searchRadius: {
            value: 10000,
            isSet: false
          }
        }
      }, () =>{ 
        this.filterWalks(this.state.filter)
        this.submitFilter()
      })
    } else if(e.currentTarget.id === 'audio') {
      
      this.setState({
        filter: {
          ...this.state.filter,
          audio: false
        }
      }, () => {
        
        this.filterWalks(this.state.filter)
        this.submitFilter()
      })
    } else if(e.currentTarget.id === 'place') {
      this.setState({
        filter: {
          ...this.state.filter,
          [e.currentTarget.id]: null,
          searchRadius: {
            value: 10000,
            isSet: false
          }
        }
      }, () => {
        this.filterWalks(this.state.filter)
        this.submitFilter()
      })
    } else {
      this.setState({
        filter: {
          ...this.state.filter,
          [e.currentTarget.id]: null
        }
      }, () => {
        this.filterWalks(this.state.filter)
        this.submitFilter()
      })
    }
  }

  handleScroll = () => {
    const header = (document.querySelector('.walkBody__header') as HTMLElement)
    if(header) {
      this.scrollHeight = document.documentElement.clientHeight - header.offsetHeight - this.backgroundMapHeight - 45
    }
  }
  
  getContent = () => {
    return document.querySelector('ion-content');
  }

  scrollToTop = () => {
    this.getContent()?.scrollToTop(500);
  }

  viewChange = () => {
    this.setState({
      viewMode: 'public'
    })
    this.props.setView('public')
  }

  handleTeam = (e: any) => {
    this.setState({
      teamId: e.detail.value
    }, () => {
      this.filterWalks(this.state.filter)
    })
    this.props.setTeam(e.detail.value)
  }

  logIn = () => {
    this.setState({
      loggedIn: this.api.loggedIn
    });
  }

  closeLoginModal = () => {
    this.props.setView('public')
  }

  closeProfile = () => {
    this.setState({openProfile: false})
  }

  reloadData = () => {
    this.fetchWalks()
  }

  render () {
    // if (this.state.disabled) {
    //   return <Disabled reloadData={this.fetchWalks}/>
    // }

    const walkNumbers = this.state.filterResult.filter(walk => {
      if(walk.booked === 0) {
        // console.log(walk)
        // fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${walk.lat},${walk.lng}&key=${CONFIG.GOOGLE_KEY}`).then(res => res.json())
        // .then(res=> console.log(res))
        return walk
      }
      return null
    })
    
    const dateString = new Date().toISOString();
    return (
      <IonPage className="cheap_desktop" id="find_walk_page">
        {/* <CurrentWalk/> */}
        { this.props.loggedIn ?
          <section className="viewControls safe_padding_top">
            <IonToolbar 
            class="flex items-center main_toolbar">
              {/* <IonBadge class="p-2 m-2" onClick={() => {
                this.setState({  filter: {...this.state.filter, audio: false}})
              }}>
                <IonIcon icon={walk}/>
                { this.state.filterResult.length }
              </IonBadge>
              <IonBadge onClick={() => {
                this.setState({
                  view: false,
                  filter: {
                    ...this.state.filter,
                    audio: true,
                    isSet: true
                }}, () => {
                  this.filterWalks(this.state.filter)
                })
              }} class="p-2 m-2" color="darkblue">
                <IonIcon icon={mic}/>
                {this.state.filterResult.filter(walk => walk.hasTalk).length}
              </IonBadge> */}
              <IonButtons slot="start">
                <IonButton shape="round" size="small" color="primary" fill="solid" routerLink='/walk/networks/explore'>
                  Explore networks
                </IonButton>
              </IonButtons>
              <IonButtons slot="end" onClick={() => {
              goToPage('/walk/teams')
            }}> 
              {this.toolbarFilter()}

                <IonButton>
                  <IonIcon icon={caretDown} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
            <IonToolbar class="flex justify-center" color="light">
              <IonRow>
                <IonCol>
                  <IonSelect 
                    class="select-style"
                    color="light"
                    onIonChange={e => this.setState({ 
                      filter: {
                        ...this.state.filter,
                        whenIsSet: true,
                        when: e.detail.value
                    }})}
                    interface="popover"
                    placeholder={this.api.tr('all')}
                    disabled={this.state.filter.date !== null ? true : false}>
                    <IonSelectOption value="today">{this.api.tr('today')}</IonSelectOption>
                    <IonSelectOption value="week">{this.api.tr('7_days')}</IonSelectOption>
                    <IonSelectOption value="month">{this.api.tr('30_days')}</IonSelectOption>
                    <IonSelectOption value="all">{this.api.tr('all')}</IonSelectOption>
                  </IonSelect>
                </IonCol>
                <IonCol class="flex justify-center">
                  <IonButtons>
                    <IonButton fill="clear" onClick={() => this.setState({view: !this.state.view})}>
                      { this.state.view ? 
                        <IonIcon icon={list} color="medium" size="large"/> :
                        <IonIcon icon={map} color="medium" size="large"/>
                      }
                    </IonButton>
                  </IonButtons>
                </IonCol>
                <IonCol class="flex justify-end">
                  <IonButtons>
                    <IonButton onClick={() => {
                      this.setState({ showFilter: true })
                    }}>
                      <IonIcon icon={filterCircle} color="medium" size="large"/>
                    </IonButton>
                  </IonButtons>
                </IonCol>
              </IonRow>
            </IonToolbar>
            { this.state.filter.isSet ? 
            <IonToolbar>
            { this.state.filter.isSet ?
                <section className="filterIsSet">
                  <section 
                    className="chipContainer" 
                    slot="start">
                      { this.state.filter.audio ?
                        <IonChip
                          color="darkblue"
                          id="audio"
                          onClick={this.clearFilterField}
                          className="p-2 ml-2 mt-2">
                          <IonLabel class="font_small">{this.api.tr('audio_walk')}</IonLabel>
                          <IonIcon icon={closeCircle} size="small"/>
                        </IonChip> 
                      : null
                    }
                    { this.state.filter.place !== null ?
                      <IonChip
                        color="teal"
                        className="p-2 ml-2 mt-2"
                        // onClick={this.clearFilterField}
                        id="place">
                          <IonLabel class="font_small">{this.state.filter.place}</IonLabel>
                          {/* <IonIcon icon={closeCircle} size="small"/> */}
                      </IonChip>
                      : null
                    }
                      { this.state.filter.searchRadius.isSet ?
                      <IonChip
                        color="teal"
                        className="p-2 ml-2 mt-2"
                        // onClick={this.clearFilterField}
                        id="searchRadius">
                          <IonLabel class="font_small">{this.state.filter.searchRadius.value / 1000} km</IonLabel>
                          {/* <IonIcon icon={closeCircle} size="small"/> */}
                      </IonChip>
                      : null
                    }
                    { this.state.filter.time !== null ?
                        <IonChip
                          color="teal"
                          id="time"
                          // onClick={this.clearFilterField}
                          className="p-2 ml-2 mt-2">
                          <IonLabel class="font_small">Kl. {this.state.filter.time}</IonLabel>
                          {/* <IonIcon icon={closeCircle} size="small"/> */}
                        </IonChip> 
                      : null
                    }
                    { this.state.filter.date !== null ?
                        <IonChip
                          color="teal"
                          id="date"
                          // onClick={this.clearFilterField}
                          className="p-2 ml-2 mt-2">
                          <IonLabel class="font_small">{this.state.filter.date}</IonLabel>
                          {/* <IonIcon icon={closeCircle} size="small"/> */}
                        </IonChip> 
                      : null
                    }
                  </section>
                  <section className="filterInfo">
                  { this.state.filter.isSet ?
                    <button 
                      onClick={this.clearFilter}
                      className="customButton customButton--clear">
                      {this.api.tr('clear_filter')}
                    </button>
                  : null
                  }
                </section>
              </section>

            : null
            }
          </IonToolbar>
          : null }
        </section>
        : null      
        }
        <IonContent
          fullscreen
          scrollEvents={true}
          onIonScroll={this.handleScroll}> 
          { this.state.filter.isSet ?
            <FilterDropdown
              filter={this.state.filter}
              openFilter={this.openFilter}
              clearFilter={this.clearFilter}
              clearFilterField={this.clearFilterField}/>
            : null
          }
            <IonModal 
              isOpen={this.state.showBooked} 
              className='modal_centered'
              backdropDismiss={false}
              onDidDismiss={() => this.setState({ showBooked: false })}>
              <div className="mx-4 text_center">
                <img 
                  className="mt-8" 
                  alt="done" 
                  src="assets/icon/x_large.svg"
                  onClick={() => this.setState({showBooked: false})}/>
                <h1 className="mt-4">Fullbokad!</h1>
                <p className="mt-4">Den här promenaden är bokad av någon annan. Skapa gärna en egen promenad eller leta vidare.</p>
                <IonButton 
                  className="mt-6" 
                  expand="block" 
                  onClick={() => this.showCreateWalk()}>
                  Skapa egen promenad
                </IonButton>
                <div 
                  className="mt-6 text_center color_green" 
                  onClick={() => this.setState({ showBooked: false })}>
                  Titta vidare
                </div>
              </div>
            </IonModal>
            <IonModal  
              isOpen={this.state.showFilter}
              onDidDismiss={() => this.setState({ showFilter: false })}
              className="modal_full filterModal">
              <ModalHeader 
                pageTitle={this.api.tr('filter_walks')}
                closeModal={this.closeModal}/>
              <IonContent class="safe_padding_bottom">
              
              <form onSubmit={this.onFilterSubmit} className="filterForm safe_padding_bottom">
                <section className="inputContainer">
                  <IonItem className="selectWrapper selectWrapper--modal space--between">
                    <IonLabel>{this.api.tr('filter_where_label')}</IonLabel>
                    <IonInput 
                      placeholder={this.api.tr('filter_where_placeholder')}
                      onIonChange={this.onInputChange}
                      id="place"
                      class="place medium_gray"
                      value={this.state.filter.place}
                      disabled={this.state.filter.myPosition ? true : false}/>
                  </IonItem>
                  <article className="myPosition">
                    <IonLabel>{this.api.tr('filter_where_position')}</IonLabel>
                    <IonCheckbox 
                      checked={this.state.filter.myPosition} 
                      onIonChange={this.onMyPositionFilterChange} 
                      id="myPosition"/>
                  </article>
                </section>
                <section className="inputContainer">
                  <IonItem className="selectWrapper selectWrapper--modal space--between">
                    <IonLabel>{this.api.tr('filter_radius_label')}</IonLabel>
                    <IonSelect 
                      placeholder={this.api.tr('filter_radius_placeholder')}
                      onIonChange={this.onRadiusInputChange}
                      value={this.state.filter.searchRadius.value}
                      id="searchRadius">
                      <IonSelectOption value={1000}>1 Km</IonSelectOption>
                      <IonSelectOption value={10000}>10 Km</IonSelectOption>
                      <IonSelectOption value={25000}>25 Km</IonSelectOption>
                      <IonSelectOption value={100000}>100 Km</IonSelectOption>
                      <IonSelectOption value={10000}>{this.api.tr('clear_choice')}</IonSelectOption>
                    </IonSelect>
                  </IonItem>
                  <p className="helpParagraph">Standard: 10km</p>
                </section>
                <section className="inputContainer">
                  <IonItem className="selectWrapper selectWrapper--modal space--between">
                    <IonLabel>{this.api.tr('filter_when_label')}</IonLabel>
                    <IonSelect 
                      placeholder={this.api.tr('filter_when_placeholder')}
                      onIonChange={this.onInputChange}
                      value={this.state.filter.time}
                      id="time">
                      <IonSelectOption value={'05-11'}>Kl. 05-11</IonSelectOption>
                      <IonSelectOption value={'12-17'}>Kl. 12-17</IonSelectOption>
                      <IonSelectOption value={'18-22'}>Kl. 18-22</IonSelectOption>
                      <IonSelectOption value={null}>{this.api.tr('clear_choice')}</IonSelectOption>
                    </IonSelect>
                  </IonItem>
                </section>
                <section className="inputContainer">
                  <IonItem onClick={() => {
                    this.setState({filtermodal: true})
                  }} className="selectWrapper selectWrapper--modal space--between">
                    <IonLabel>{this.api.tr('filter_day_label')}</IonLabel>
                  </IonItem>
                  <IonModal 
                      className="modal_centered"
                      isOpen={this.state.filtermodal === true} 
                      onDidDismiss={() => this.setState({filtermodal: false})}>
                        <IonHeader>
                          <IonToolbar>
                            <IonButtons slot="end" >
                              <IonButton onClick={() => {
                                this.setState({filtermodal: false})}}>
                                <IonIcon icon={close} />
                              </IonButton>
                            </IonButtons>
                            <IonTitle>{this.api.tr('filter_day_placeholder')}</IonTitle>
                          </IonToolbar>
                        </IonHeader>
                        <IonContent class="flex justify-center items-center p-2">
                          <IonDatetime 
                            placeholder={this.api.tr('filter_day_placeholder')}
                            // displayFormat="YYYY/MMM/DD"
                            locale="sv-SE"
                            min={dateString}
                            onIonChange={this.onDateInputChange}
                            id="date"/>
                            <IonButton class="fullWidth" 
                              onClick={() => this.setState({filtermodal: false})}>
                              {this.api.tr('filter_day_placeholder')}
                            </IonButton>
                        </IonContent>
                    </IonModal>

                </section>
                  <IonButton 
                    expand="block"
                    type="submit"
                    class="m-2"
                    onSubmit={this.onFilterSubmit}>{this.api.tr('filter_walks')}</IonButton>
                    { this.state.submitError ?
                      <section className="errorWrapper">
                        <p className="flex justify-center color_red">{this.state.errorString}</p>
                      </section>
                      : null
                    }
                </form>
              </IonContent>
            </IonModal>
            <section 
              className="overviewMap"
              id="OverviewMap"
              style={{ 
                // width: this.backgroundMapWidthPx, 
                // height: this.backgroundMapHeightPx,
                position: 'relative'}}>
              {
                this.state.loaded && this.state.view &&
                  <MapContainer 
                    history={this.props.history} 
                    goTo={this.goToWalk}
                    markers={this.state.markers} 
                    height={window.innerHeight - 170}
                    filter={this.state.filter}
                    setNearby={this.setNearby}
                    walksOnSameOpen={this.state.walksOnSameOpen}/>
              }
              { this.state.view ? 
              <IonButton 
                color="darkblue"
                onClick={() => {
                  this.setState({
                    view: false,
                    filter: {
                      ...this.state.filter,
                      audio: true,
                      isSet: true
                  }}, () => {
                    this.filterWalks(this.state.filter)
                  })
                }}
                class="button_rounded">
                  Audio
                <IonIcon icon={walk} />
              </IonButton> : null }
            </section> 

              {
               !this.state.view && this.state.filterResult.map((walk: any, key: number) => {
                  if(walk.booked === 0) {
                    const markers = [
                      {
                        lat: walk.lat,
                        lng: walk.lng,
                      }
                    ]
                    let bookText: string;
                    let full: boolean;
                    if (walk.bookings >= walk.maxBookings) {
                      bookText = 'Bokad';
                      if (walk.bookedByYou) {
                        bookText += ' av dig';
                        full = false;
                      } else if (walk.editable) {
                        full = false;
                      } else {
                        full = true;
                      }
                    } else {
                      if(walk.bookings === 0) {
                        bookText = (walk.bookings) + ' / ' + (walk.maxBookings)
                      } else {
                        bookText = (walk.bookings) + ' / ' + (walk.maxBookings);
                        full = false;
                      }
                    }
                    return (
                      <div key={'walk' + key + walk.id} className="mt-8 mx-4">
                        <div 
                          onClick={() => {
                            this.setState({
                              chosenPerson: {
                                firstName: walk.personName,
                                id: walk.personId,
                                picture: walk.personPicture
                              },
                              // openProfile: true,
                            })
                            goToPage('/walk/user/profile/' + walk.personId)
                          }} 
                          className="flex items-center pos-relative walk_id">
                          <div>
                            <img className="circle_picture" alt={walk.personName} src={walk.personPicture}/>
                          </div>
                          <div className="mx-2">
                            <p>{walk.personName}</p>
                          
                          </div>
                          { walk.teamId !== null ? 
                           <>{ walk.privateWalk ? 
                            <IonChip class="chip chip--blue">
                              { walk.editable === 1 ? 
                                <IonIcon icon={send} color="light"/>
                               :
                                <IonIcon icon={lockClosed} color="light"/> 
                              }
                              <IonLabel color="light">
                                { walk.availableTo.length > 1 ? 
                                  ' Grupp'
                                  :
                                  walk.availableTo[0].name
                                }
                              </IonLabel>
                            </IonChip> 
                            : 
                            <IonChip class="chip chip--blue">
                              <IonIcon icon={people} color="light"/>
                              <IonLabel color="light">{this.props.user.teams.map((team: any, key: number) => {
                                if(walk.teamId === team.teamId) {
                                  return team.teamName
                                }
                                return null
                              })}</IonLabel>
                            </IonChip>
                          }</>
                              
                            : null
                          }
                        </div>
                        <IonCard 
                          className="walk_card mt-4" 
                          onClick={() => {
                            this.goToWalk(walk.id, full)
                          }}>
                          <section className="pos-relative">
                          { walk.hasCoordinates && walk.address !== '' ?
                            <section className="cardAddress">
                              <IonChip class="chip">
                                <IonIcon icon={locationOutline} color="primary" />
                                <IonLabel color="dark">{walk.address}</IonLabel>
                              </IonChip>
                              { walk.hasCoordinates && walk.hasTalk ? 
                                <IonChip class="chip">
                                  <IonIcon icon={mic} color="darkblue" />
                                  / 
                                  <IonIcon icon={walkOutline} color="darkblue" /> 
                                </IonChip> 
                                : 
                                <IonChip class="chip">
                                  <IonIcon icon={walkOutline} color="darkblue" /> 
                                </IonChip> 
                                }
                            </section>
                          : null }

                          { walk.hasCoordinates ? 
                            <GoogleMapImage 
                              markers={markers} 
                              width={this.mapWidth} 
                              height={this.mapHeight}
                              classes="rounded_top"/> 
                              : 
                            <section className="audio p-2 flex justify-end items-center background_teal">
                              <h2>{this.api.tr('audio_walk')}</h2>
                              <IonChip class="chip">
                                <IonIcon icon={mic} color="darkblue"/> 
                              </IonChip>
                            </section>
                            }
                          </section>
                          <div className="p-4">
                            <h2>{walk.name}</h2>
                            <div className="flex justify-between mt-2">
                              <div className="gray_medium uppercase_first">
                                {formatDate(walk.start)}-{formatEnd(walk.start, walk.lengthMinutes)}
                              </div>
                              <div className="gray_medium flex items-center">
                                {bookText} 
                                <IonIcon icon={walk.maxBookings > 1 ? people : person} color="primary" class="ml-1"/>
                              </div>
                            </div>
                          </div>
                        </IonCard>
                      </div>
                    )
                }
                  return <section key={'section' + key}></section>
                })
              }
              { !this.state.loaded ? 
              <IonLoading
                cssClass='my-custom-class'
                isOpen={!this.state.loaded}
                message={'Please wait...'}
                duration={5000}
              />
              :
              <>
              { this.state.filterResult.length === 0 ?
                <section className="filterInfo filterInfo--column p-2">
                  <p>{this.api.tr('no_walks_found')}</p>
                  <IonButton
                    onClick={() => {
                      this.props.history.push({
                        pathname: '/walk/create',
                      })
                    }}>
                    {this.api.tr('create_a_walk')}
                  </IonButton>
                </section>
                : null
              }
              { this.state.filterResult.length !== 0 && walkNumbers.length === 0  ?
                <section className="filterInfo flex-col">
                  <p>{this.api.tr('all_filtered_booked')}</p>
                  <IonButton
                    onClick={() => {
                      this.props.history.push({
                        pathname: '/walk/create',
                      })
                    }}>
                    {this.api.tr('create_a_walk')}
                  </IonButton>
                </section>
                : null
              }
              </> }


              {/*<div className="mt-4 text_center" onClick={() => this.showTesting()}>*/}
              {/*  Testing*/}
              {/*</div>*/}
          { !this.state.view ? <section className="mt-16"></section> : null}
        </IonContent>
      </IonPage>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    friends: state.friends,
    logIn: state.logIn,
    allWalks: state.walks.walks,
    location: state.logIn.position,
    user: state.logIn.user,
    viewMode: state.logIn.viewMode,
    loggedIn: state.logIn.loggedIn,
    teamFilter: state.teamFilter.team
  }
}

const mapDispatchToProps = {
  setView,
  setTeam,
  updateFilter,
  setFilterTeamArrAction,
  openPreview, 
  closePreview
}

export default connect(mapStateToProps, mapDispatchToProps)(withIonLifeCycle(HomePage));
